import React from 'react';
import { SimpleTabs } from 'components';
import { Images } from 'utils';
import { DrawSignature } from './drawSignature';
import { TypeSignature } from './typeSignature';
import { SIGNATURE_TAB, SIGNATURE_TABS_LABELS } from './constants';

export const SignatureCard = ({ activeTab, setActiveTab, onCanvasRef, onDrawingChange, typedName, setTypedName }) => {
    const tabsContent = [
        {
            tab: SIGNATURE_TAB.DRAW,
            tabComponent: <DrawSignature onCanvasRef={onCanvasRef} onDrawingChange={onDrawingChange} />,
        },
        {
            tab: SIGNATURE_TAB.TYPE,
            tabComponent: <TypeSignature typedName={typedName} onNameChange={setTypedName} />,
        },
    ];

    return (
        <div className="signature-request-card">
            <div className="signature-request-card-header">
                <img src={Images.signaturePenBlue} alt="signature" />
                <p>Client/Guardian Signature</p>
            </div>

            <div className="signature-request-card-body">
                <SimpleTabs
                    customTabPanel={'signature-request-tab-panel'}
                    getTab={setActiveTab}
                    tab={activeTab}
                    defaultTab={SIGNATURE_TAB.DRAW}
                    tabsLabels={SIGNATURE_TABS_LABELS}
                    tabsContent={tabsContent}
                />
            </div>
        </div>
    );
};
